<!-- 图片预览 -->
<template>
  <div class="mask-layer-box" v-if="value">
    <div class="img-pre-box" :style="preImgBoxStyle">
      <div class="img-wrap" v-if="!imgIsLoading">
        <img :src="preImgUrl" alt="">
        <i class="el-icon-error img-pre-close" @click="closePreImg()"></i>
      </div>
      <i class="el-icon-loading loading-icon" style="font-size: 30px" v-else></i>
    </div>
    <div class="img-pre-op-box" v-if="preImgList.length > 0">
      <i class="el-icon-arrow-left opt-icon img-pre-before" @click="funBefore()" v-if="preIndex > 0"></i>
      <i class="el-icon-arrow-right opt-icon img-pre-next"
         @click="funNext()" v-if="preIndex < preImgList.length - 1"></i>
    </div>
  </div>
</template>

<script>
  export default {
    name: "hllImgPreview",
    props: {
      value: {
        type: Boolean,
        default: false
      },
      data: {
        type: [String, Array],
        default: ''
      },
      index: {
        type: Number,
        default: 0 // 当接收图片数组时，默认从第几张开始预览。（从0开始）
      }
    },
    data() {
      return {
        preImgList: [], // 可接收图片数组
        preImgUrl: '',
        preIndex: 0, // 当前图片index
        preImgBoxStyle: {},
        imgIsLoading: false
      }
    },
    watch: {
      value(newVal, oldVal) {
        if(newVal && newVal != oldVal) {
          this.init();
        } 
      }
    },
    methods: {
      init() {
        this.preImgList = [];
        if(!Array.isArray(this.data)) {
          this.preImgList.push(this.data);
        } else {
          this.preImgList = this.data;
        }
        this.preIndex = this.index || 0;
        this.funPreImg();
      },
      funBefore() {
        if(this.preIndex <= 0) {
          return ;
        }
        this.preIndex--;
        this.funPreImg();
      },
      funNext() {
        if(this.preIndex >= this.preImgList.length - 1) {
          return ;
        }
        this.preIndex++;
        this.funPreImg();
      },
      funPreImg() {
        this.imgIsLoading = true
        this.preImgBoxStyle = {}
        let newImg = new Image();
        this.preImgUrl = this.preImgList[this.preIndex];
        newImg.onload = () => {
          this.imgIsLoading = false
          let wUse = document.documentElement.clientWidth * 0.8;
          let hUse = document.documentElement.clientHeight * 0.8;
          let percent = Math.max(newImg.width / wUse, newImg.height / hUse);
          let boxWidth = newImg.width;
          let boxHeight = newImg.height;

          if(percent > 1) {
            boxWidth = boxWidth / percent;
            boxHeight = boxHeight / percent;
          }
          this.preImgBoxStyle = {
            width: boxWidth + 'px',
            height: boxHeight + 'px',
            marginTop: (0 - boxHeight / 2) + 'px',
            marginLeft: (0 - boxWidth / 2) + 'px'
          }
        }
        newImg.onerror = () => {
          this.imgIsLoading = false
        }
        newImg.src = this.preImgUrl;
      },
      closePreImg() {
        this.preImgList = [];
        this.preIndex = 0;
        this.preImgUrl = '';
        this.preImgBoxStyle = {};
        this.$emit("input", false);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .mask-layer-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 9999;
    overflow: auto;
  }
  .img-pre-box {
    position: absolute;
    top: 50%;
    left: 50%;
    min-width: 300px;
    min-height: 200px;
    margin-top: -100px;
    margin-left: -150px;
    .loading-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -20px;
      margin-left: -20px;
      color: #fff;
    }
    .img-wrap {
      width: 100%;
      height: 100%;
      position: relative;
      img {
        width: 100%;
        vertical-align: top;
      }
      .img-pre-close {
        width: 24px;
        height: 24px;
        display: inline-block;
        position: absolute;
        top: -10px;
        right: -10px;
        cursor: pointer;
        line-height: 24px;
        background: #ddd;
        border-radius: 50%;
        font-size: 24px;
      }
    }
  }
  .img-pre-op-box {
    display: inline-block;
    width: 100%;
    height: 30px;
    position: absolute;
    top: 50%;
    margin-top: -15px;
    color: #fff;
    .opt-icon {
      position: absolute;
      width: 30px;
      height: 30px;
      background: #666;
      border-radius: 50%;
      text-align: center;
      font-size: 20px;
      line-height: 30px;
      cursor: pointer;
    }
    .img-pre-before {
      left: 100px;
    }
    .img-pre-next {
      right: 100px;
    }
  }
</style>>
  



// WEBPACK FOOTER //
// src/components/common/hll-img-preview.vue